// src/components/initiatives/SuccessSnapshots.jsx
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Replace with your actual images
import case1 from "../../assets/images/case-studies/case1.jpg";
import case2 from "../../assets/images/case-studies/case2.jpg";
import case3 from "../../assets/images/case-studies/case3.jpg";

const cases = [
  {
    id: "csr-education",
    image: case1,
    title: "CSR-Backed Education Program",
    summary: "Improved learning outcomes for 5,000+ students across 10 rural districts.",
  },
  {
    id: "women-empowerment",
    image: case2,
    title: "Women Empowerment Initiative",
    summary: "Trained 200+ women in entrepreneurship, leading to 70% increase in income.",
  },
  {
    id: "policy-advocacy",
    image: case3,
    title: "Policy Advocacy on SDG Goals",
    summary: "Enabled alignment of 3 state-level policies with UN SDGs through research-backed lobbying.",
  },
];

const SuccessSnapshots = () => {
  return (
    <section className="py-20 bg-gradient-to-bl from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-primary mb-12"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Success Snapshots
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {cases.map((item, i) => (
            <motion.div
              key={i}
              className="relative overflow-hidden rounded-2xl shadow-lg group cursor-pointer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-90 group-hover:opacity-100 transition duration-300 flex flex-col justify-end p-6">
                <h3 className="text-xl font-semibold text-white mb-2">{item.title}</h3>
                <p className="text-sm text-gray-100 mb-3">{item.summary}</p>
                <Link
                  to={`/case-studies/${item.id}`}
                  className="text-sm font-medium text-secondary hover:underline"
                >
                  Learn More →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessSnapshots;
